export default __webpack_public_path__ + "static/media/scratch8.74123302.mp3";